module.exports = __webpack_public_path__ + "static/media/demisuite2.ff0c7c8f.jpg";